import { USER_TYPE } from '../../utils/constants';

const hideInvoiceFields = [USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN, USER_TYPE.PREMIUM_MPD_MANAGER, USER_TYPE.PREMIUM_MPD_USER];

const columns = (renderCell, renderJsonField, renderOrderField, renderPicturesCell, RenderSubmittedToInvoiceField, RenderReadyToInvoiceField, user) => {
  return [
    {
      field: 'timestamp',
      headerName: 'Timestamp',
      width: 250,
      hide: false,
      renderCell,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'userEmail',
      headerName: 'Email',
      width: 300,
      renderCell,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'BinNum',
      headerName: 'Box Name',
      width: 200,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'division',
      headerName: 'Division',
      width: 300,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      sortable: false
    },
    {
      field: 'type',
      headerName: 'Type',
      width: 200,
      renderCell,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'orderNumber',
      headerName: 'Order Number',
      width: 200,
      renderCell: renderOrderField,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'ReadyForInvoice',
      headerName: 'Ready For Invoice',
      width: 200,
      renderCell: (params) => (
      <RenderReadyToInvoiceField row={params.row} />
      ),
      headerAlign: 'center',
      align: 'center',
      hide: hideInvoiceFields.includes(user?.type)
    },
    {
      field: 'submittedToInvoice',
      headerName: 'Submitted To Invoice',
      width: 200,
      renderCell: (params) => (
      <RenderSubmittedToInvoiceField row={params.row} />
      ),
      headerAlign: 'center',
      align: 'center',
      hide: hideInvoiceFields.includes(user?.type)
    },
    {
      field: 'pictures',
      headerName: 'Pictures',
      width: 120,
      renderCell: renderPicturesCell,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'payload',
      headerName: 'Input',
      width: 250,
      renderCell: renderJsonField,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'response',
      headerName: 'Response',
      width: 250,
      renderCell: renderJsonField,
      headerAlign: 'center',
      align: 'center',
    },
  ];
};

export default columns;
